module.exports = __webpack_public_path__ + "static/media/FWI_2.2fc77931.jpg";